<template>
  <el-dialog
    append-to-body
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="620px"
    :close-on-click-modal="false"
    @close="onClose"
  >
    <el-form ref="form" :model="form" :rules="currentRules" label-width="100px">
      <el-form-item v-if="showPackageCountField" label="包数" prop="package_count">
        <el-input
          v-model.trim="form.package_count"
          placeholder="请输入包数"
          class="w-96"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="showPutAreaField" label="放柜区域" prop="put_area">
        <el-select
          v-model="form.put_area"
          clearable
          filterable
          placeholder="请选择放柜区域"
          class="w-96"
        >
          <el-option
            v-for="item in areaOption"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      loadingArea: false,
      activeField: "",
      areaOption: [],
      form: this.getDefaultForm(),
      rules: {
        package_count: [
          { required: true, message: "请输入包数", trigger: "blur" }
        ]
      }
    };
  },
  computed: {
    // 根据入口字段动态调整弹窗标题，保持用户操作目标明确。
    dialogTitle() {
      if (this.activeField === "package_count") {
        return "修改包数";
      }
      if (this.activeField === "put_area") {
        return "修改放柜区域";
      }
      return "修改国废字段";
    },
    // 包数入口只展示包数字段，避免一次改动带出其他字段。
    showPackageCountField() {
      return this.activeField !== "put_area";
    },
    // 放柜区域入口只展示放柜区域字段，避免一次改动带出其他字段。
    showPutAreaField() {
      return this.activeField !== "package_count";
    },
    // 校验规则跟随当前入口切换，避免隐藏字段仍参与校验。
    currentRules() {
      return this.showPackageCountField
        ? this.rules
        : {};
    }
  },
  methods: {
    // 统一返回默认表单，避免多次编辑不同预约时字段串值。
    getDefaultForm() {
      return {
        booking_id: "",
        package_count: "",
        put_area: "",
        put_area_name: ""
      };
    },
    // 打开弹窗时回填当前详情中的国废字段，支持只改包数或只改放柜区域。
    async onOpen(detail, fieldName = "") {
      this.activeField = fieldName;
      this.form = Object.assign(this.getDefaultForm(), {
        booking_id: detail.id || "",
        package_count:
          detail.package_count === null || detail.package_count === undefined
            ? ""
            : String(detail.package_count),
        put_area: detail.put_area || "",
        put_area_name: detail.put_area_name || ""
      });
      this.dialogVisible = true;
      if (this.showPutAreaField && !this.areaOption.length) {
        await this.getPutArea();
      }
    },
    // 查询放柜区域基础数据，复用现有 SAP 下拉数据源。
    async getPutArea() {
      this.loadingArea = true;
      try {
        const dataObj = await this.$common.http({
          url: "/api/sap/query_put_area"
        });
        this.areaOption = (dataObj.data.data || []).map(item => {
          return {
            ...item,
            label: `${item.put_area_name}（${item.put_area_code}）`,
            value: item.put_area_id
          };
        });
      } finally {
        this.loadingArea = false;
      }
    },
    // 关闭弹窗时清理表单与校验状态。
    onClose() {
      this.activeField = "";
      this.form = this.getDefaultForm();
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate();
      });
    },
    // 根据字段入口只组装当前需要更新的参数，避免误改其它国废字段。
    buildSubmitPayload() {
      const payload = {
        booking_id: this.form.booking_id
      };
      if (this.activeField === "package_count") {
        payload.package_count = this.form.package_count;
        return payload;
      }
      if (this.activeField === "put_area") {
        payload.put_area = this.form.put_area;
        payload.put_area_name = this.form.put_area_name;
        return payload;
      }
      payload.package_count = this.form.package_count;
      payload.put_area = this.form.put_area;
      payload.put_area_name = this.form.put_area_name;
      return payload;
    },
    // 提交时带上放柜区域名称，方便后端直接落库并记录留痕。
    onConfirm() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        const selectedArea = this.areaOption.find(
          item => item.value === this.form.put_area
        );
        this.form.put_area_name = selectedArea ? selectedArea.label : this.form.put_area_name;
        await this.$common.http({
          url: "/api/queue/admin/update_guofei_booking_fields",
          data: this.buildSubmitPayload()
        });
        this.$message.success("国废字段修改成功");
        this.dialogVisible = false;
        this.$emit("ok");
      });
    }
  }
};
</script>

<style lang="less" scoped></style>
